import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/users/cloud-user/';

type CloudUser = {
    id: string;
    created_at: string;
    modified_at: string;
    cloud_id: string;
    email: string;
    name: string;
    is_active: boolean;
    role: string | null;
};

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    parkingId: string;
    validator_account?: string;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<CloudUser>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_CLOUD_USERS_RESOURCE, useQueryHook as useListCloudUsers };
export type { CloudUser };
